module.exports = __webpack_public_path__ + "img/back-icon-old.9df57c81.svg";